"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("./Buttons/Button"));
var _color = _interopRequireDefault(require("./styles/color"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _Row = _interopRequireDefault(require("./Row"));
var _Column = _interopRequireDefault(require("./Column"));
var _Text = _interopRequireDefault(require("./Text"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
}; // $FlowFixMe
var Container = _styledComponents["default"].div.withConfig({
  displayName: "Container",
  componentId: "sc-ci2jb5-0"
})(["display:block;position:absolute;top:10px;right:10px;z-index:1000;@media (max-width:412px){top:0;width:100%;right:0;}"]);
Container.displayName = 'Container';
/* istanbul ignore next */
var NotificationContainer = _styledComponents["default"].div.withConfig({
  displayName: "NotificationContainer",
  componentId: "sc-ci2jb5-1"
})(["display:block;position:relative;padding:15px;overflow:hidden;width:300px;border-radius:4px;box-shadow:0 16px 32px rgba(47,56,62,0.13);color:#fff;", " text-align:center;background-color:", ";@media (max-width:412px){width:100%;padding-right:0;padding-left:0;padding-top:9px;padding-bottom:9px;box-shadow:0 4px 4px rgba(0,0,0,0.25);}@-webkit-keyframes show-notification{0%{opacity:0;-webkit-transform:translate(0,-100%);}10%{opacity:0.5;-webkit-transform:translate(0,0);}20%{opacity:1;-webkit-transform:translate(0,0);}80%{opacity:1;-webkit-transform:translate(0,0);}90%{opacity:0.5;-webkit-transform:translate(0,0);}100%{opacity:0;-webkit-transform:translate(0,-100);}}@keyframes show-notification{0%{opacity:0;-webkit-transform:translate(0,-100%);transform:translate(0,-100%);}10%{opacity:0.5;-webkit-transform:translate(0,0);transform:translate(0,0);}20%{opacity:1;-webkit-transform:translate(0,0);transform:translate(0,0);}50%{opacity:1;-webkit-transform:translate(0,0);transform:translate(0,0);}80%{opacity:1;-webkit-transform:translate(0,0);transform:translate(0,0);}90%{opacity:0.5;-webkit-transform:translate(0,0);transform:translate(0,0);}100%{opacity:0;-webkit-transform:translate(0,-100);transform:translate(0,-100);}}@-webkit-keyframes show-notification-no-hide{0%{opacity:0;-webkit-transform:translate(0,-100%);}10%{opacity:0.5;-webkit-transform:translate(0,0);}20%{opacity:1;-webkit-transform:translate(0,0);}100%{opacity:1;-webkit-transform:translate(0,0);}}@keyframes show-notification-no-hide{0%{opacity:0;-webkit-transform:translate(0,-100%);transform:translate(0,-100%);}10%{opacity:0.5;-webkit-transform:translate(0,0);transform:translate(0,0);}20%{opacity:1;-webkit-transform:translate(0,0);transform:translate(0,0);}50%{opacity:1;-webkit-transform:translate(0,0);transform:translate(0,0);}100%{opacity:1;-webkit-transform:translate(0,0);transform:translate(0,0);}}"], function (props) {
  if (props.autoClose === 0) {
    return "\n        -webkit-animation: show-notification-no-hide 5s ease-out;\n        animation: show-notification-no-hide 5s ease-out;\n    ";
  } else {
    return "\n        -webkit-animation: show-notification ".concat(props.autoClose, "s ease-out;\n        animation: show-notification ").concat(props.autoClose, "s ease-out;\n    ");
  }
}, function (props) {
  return props.color;
});
NotificationContainer.displayName = 'NotificationContainer';
var CloseButton = _styledComponents["default"].button.withConfig({
  displayName: "CloseButton",
  componentId: "sc-ci2jb5-2"
})(["padding:0;cursor:pointer;background:none;border:0;outline:none;-webkit-appearance:none;color:", ";text-shadow:0 1px 0 #ddd;@media (min-width:413px){position:absolute;top:15px;right:10px;}"], _color["default"].white);
CloseButton.displayName = 'CloseButton';
var Center = _styledComponents["default"].div.withConfig({
  displayName: "Center",
  componentId: "sc-ci2jb5-3"
})(["display:inline-block;width:100%;"]);
Center.displayName = 'Center';
var Notification = /*#__PURE__*/function (_Component) {
  _inherits(Notification, _Component);
  var _super = _createSuper(Notification);
  function Notification(props) {
    var _this;
    _classCallCheck(this, Notification);
    _this = _super.call(this, props);
    _this.state = {
      show: props.show
    };
    return _this;
  }
  _createClass(Notification, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(props) {
      this.setState({
        show: props.show
      });
    }
  }, {
    key: "setTimer",
    value: function setTimer() {
      var _this2 = this;
      var autoClose = this.props.autoClose;
      if (this.state.show && autoClose && autoClose !== 0) {
        window.setTimeout(function () {
          return _this2.onClose();
        }, autoClose * 1000);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setTimer();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setTimer();
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      var _this$props = this.props,
        icon = _this$props.icon,
        type = _this$props.type;
      if (icon) {
        return icon;
      }
      var iconName;
      var spin = false;
      var pulse = false;
      switch (type) {
        case 'warning':
          iconName = 'warning';
          break;
        case 'info':
          iconName = 'info';
          break;
        case 'success':
          iconName = 'checkCircle';
          break;
        case 'error':
          iconName = 'close';
          break;
        case 'loading':
          iconName = 'spinner';
          spin = true;
          pulse = true;
          break;
        default:
          iconName = '';
      }
      var size = window.innerWidth <= 412 ? '1x' : '2x';
      return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        iconName: iconName,
        size: size,
        spin: spin,
        pulse: pulse,
        color: _color["default"].white
      });
    }
  }, {
    key: "getColor",
    value: function getColor() {
      var type = this.props.type;
      switch (type) {
        case 'info':
        case 'loading':
          return _color["default"].info;
        case 'success':
          return _color["default"].success;
        case 'error':
          return _color["default"].danger;
        case 'warning':
          return _color["default"].warning;
        default:
          return _color["default"].info;
      }
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.setState({
        show: false
      });
      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }, {
    key: "getButton",
    value: function getButton(backgroundColor) {
      var _this$props2 = this.props,
        buttonText = _this$props2.buttonText,
        onClick = _this$props2.onClick,
        type = _this$props2.type;
      if (!buttonText || !onClick) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_Row["default"], {
        classNames: ['is-mobile', 'is-vcentered', 'is-gapless']
      }, /*#__PURE__*/_react["default"].createElement(_Column["default"], {
        classNames: ['is-6 is-offset-3']
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        fill: true,
        outline: true,
        title: buttonText,
        onClick: onClick,
        style: type === 'loading' ? 'info' : type
      })));
    }
  }, {
    key: "getNotification",
    value: function getNotification() {
      var _this3 = this;
      var message = this.props.message || 'Loading...';
      var icon = this.getIcon();
      var notificationColor = this.getColor();
      var autoClose = this.props.autoClose;
      var button = this.getButton(notificationColor);
      return /*#__PURE__*/_react["default"].createElement(Container, {
        "data-testid": "Container"
      }, /*#__PURE__*/_react["default"].createElement(NotificationContainer, {
        color: notificationColor,
        autoClose: autoClose
      }, /*#__PURE__*/_react["default"].createElement(Center, null, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
        classNames: ['is-mobile', 'is-vcentered', 'is-gapless']
      }, /*#__PURE__*/_react["default"].createElement(_Column["default"], {
        classNames: ['is-3']
      }, icon), /*#__PURE__*/_react["default"].createElement(_Column["default"], {
        classNames: ['is-6']
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        text: message,
        textSize: "h4",
        fontColor: _color["default"].white,
        align: "left",
        fontWeight: "500",
        lineHeight: "24px"
      })), /*#__PURE__*/_react["default"].createElement(_Column["default"], {
        classNames: ['is-1', 'is-offset-2']
      }, /*#__PURE__*/_react["default"].createElement(CloseButton, {
        onClick: function onClick() {
          return _this3.onClose();
        }
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        iconName: "x",
        size: "2x",
        color: _color["default"].white
      })))), button)));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.show) {
        return null;
      }
      return this.getNotification();
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return Notification;
}(_react.Component);
exports["default"] = Notification;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(Container, "Container", "/Users/crs/WebstormProjects/michelangelo/src/Components/Notification.js");
  reactHotLoader.register(NotificationContainer, "NotificationContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/Notification.js");
  reactHotLoader.register(CloseButton, "CloseButton", "/Users/crs/WebstormProjects/michelangelo/src/Components/Notification.js");
  reactHotLoader.register(Center, "Center", "/Users/crs/WebstormProjects/michelangelo/src/Components/Notification.js");
  reactHotLoader.register(Notification, "Notification", "/Users/crs/WebstormProjects/michelangelo/src/Components/Notification.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();